import { useEffect } from 'react';
import { BottomSheet, Screen } from '@bonanza-social/navigation';
import PlayWithCoinsBanner from '../../components/PlayWithCoinsBanner/PlayWithCoinsBanner';
import {
  selectAuthenticationStatus,
  useSelector,
} from '@bonanza-social/toolkit/state';
import { selectCoinGameIds } from '../../state';
import GamesGrid from '../../components/GamesGrid/GamesGrid';
import UserSettingsService from '../../services/UserSettingsService/UserSettingsService';
import { logError } from '@bonanza-social/toolkit/logging';
import useGames from '../../hooks/useGames';

function PlayWithCoinsScreen() {
  useGames();
  const coinGameids = useSelector(selectCoinGameIds);
  const authStatus = useSelector(selectAuthenticationStatus);
  const isAuthenticated = authStatus === 'authenticated';

  useEffect(() => {
    const fetch = async () => {
      try {
        const userSettings = await UserSettingsService.getUserSettings();

        if (userSettings.shouldShowCoinsPlayInfo) {
          BottomSheet.open({
            namespace: 'games',
            type: 'PlayWithCoinsInfo',
          });
        }
      } catch (error) {
        logError('PlayWithCoinsScreen, user settings request failure.', error);
      }
    };

    if (isAuthenticated) {
      fetch();
    }
  }, [isAuthenticated]);

  return (
    <Screen paddingHorizontal="space-0">
      <GamesGrid
        gameIds={coinGameids}
        ListHeaderComponent={PlayWithCoinsBanner}
        contentContainerStyle={{
          paddingBottom: 'safe-area-inset-bottom',
        }}
        imageType="custom"
        currencyCode="BTY"
      />
    </Screen>
  );
}

export default PlayWithCoinsScreen;
